import { render, staticRenderFns } from "./BaseLeftArrow.vue?vue&type=template&id=bc0bd7fe"
import script from "./BaseLeftArrow.vue?vue&type=script&lang=js"
export * from "./BaseLeftArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports